

jQuery(document).ready(function ($){
  function quickView() {
    /* Event Handlers for elements inside quickview */
    
    jQuery(document).on('click','#quick-view .js-product__seeMore', function () {
        $('#quick-view .product__description').toggleClass('product__description--toggle');
      
      $(this).text($(this).text() == 'see more' ? 'see less' : 'see more');
    });
    

    const original_state = window.location.pathname;

    
    jQuery(document).on('click','.quick-view', function () {
      if ($('#quick-view').length == 0) {
        $("body").append('<div id="quick-view"></div>');
      }
      let product_handle = $(this).data('handle');
      let product_id = $(this).data('id');
  
      /* Grab reviews */
      let reviews = $(this).closest(".grid__item").find(".pwr-category-snippets").clone();
      fetch(`${window.Shopify.routes.root}products/${product_handle}?view=[product]`).then(function(response) {
        return response.text();
      }).then((state) => {
        const parser = new DOMParser();
        const pdp = parser.parseFromString(state, "text/html");
        if (pdp.querySelector(".breadcrumbs") !== null) {pdp.querySelector(".breadcrumbs").remove();}
        if (pdp.querySelector("#widget-modal") !== null) {pdp.querySelector("#widget-modal").remove();}
        if (pdp.querySelector(".product-media-modal") !== null) {pdp.querySelector(".product-media-modal").remove();}
        if (pdp.querySelector(".buynow") !== null) {pdp.querySelector(".buynow").remove();}
        if (pdp.querySelector("pickup-availability") !== null) {pdp.querySelector("pickup-availability").remove();}
        if (pdp.querySelector("product-form") !== null) {pdp.querySelector("product-form").classList.add("quick-view-product-form");}
        
        pdp.querySelector(".form").classList.add("quick-view-product-form-element");
        let form_id = pdp.querySelector(".form").getAttribute('id');
        let new_form_id = form_id + "-quick-view";
        pdp.querySelector(".form").setAttribute("id", new_form_id);
        if (pdp.querySelector("variant-radios") !== null) {
        pdp.querySelector("variant-radios").setAttribute("data-section", new_form_id);
        pdp.querySelector("variant-radios").classList.add("quick-view-variant-radios");
        }
        let old_form_elements = pdp.querySelectorAll("*[form=" + form_id + "]");
        old_form_elements.forEach((element) => {
          element.setAttribute("form", new_form_id);
        });
         pdp.querySelectorAll("variant-radios input").forEach((element) => {
           let old_id = element.getAttribute("id");
          element.setAttribute("id", old_id + "-quick-view");
           pdp.querySelector("variant-radios label[for=" + old_id + "]").setAttribute("for", old_id + "-quick-view")
        });
        let product = pdp.querySelector(".product-section");
        document.querySelector("#quick-view .quick-view-content").appendChild(product);
      }).finally(() => {
        let newURL = Shopify.routes.root + 'products/' + product_handle;
        console.log("New url is: " + newURL)
        window.history.replaceState({ }, '', newURL);
        $("#quick-view #pr-reviewsnippet").append(reviews);
        $("#quick-view .js-pdpFeaturedGallery").slick({
            dots: false,
            infinite: true,
            autoplay: false,
            arrows: true,
            prevArrow: `<span class="pdpProduct__prev pdpProduct__nav"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>
</span>`,
            nextArrow: `<span class="pdpProduct__next pdpProduct__nav"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>
</span>`,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '#quick-view .js-pdpThumbnailGallery',
            rows: 0
        });
        $("#quick-view .js-pdpThumbnailGallery").slick({
            dots: false,
            infinite: true,
            autoplay: false,
            arrows: true,
            prevArrow: `<span class="pdpProduct__prev pdpProduct__nav"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>
</span>`,
            nextArrow: `<span class="pdpProduct__next pdpProduct__nav"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>
</span>`,
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '#quick-view .js-pdpFeaturedGallery',
            focusOnSelect: true,
            rows: 0
        });
        
        var checkExist = setInterval(function() {
          if (window.ReChargeWidget) {
        const config = {
        productId: product_id, // Required
        injectionParent: document.querySelector("#quick-view .rc-widget-injection-parent"), // The node that will have the widget injected in
        injectionMethod: 'prepend', // How will the widget be injected 
        injectFn: (node, target) => {}, // Runs a custom injection function 
          selectors: {
              variant: ['variant-radios input']
              }
    
      };
        window.ReChargeWidget.createWidget(config);
            clearInterval(checkExist);
          }
        }, 100);
        
      });
 
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $.fancybox({
          href: '#quick-view',
          wrapCSS: 'fancy-quick-view',
          maxWidth: 1040,
          maxHeight: 600,
          fitToView: true,
          width: '80%',
          height: '70%',
          autoSize: false,
          closeClick: false,
          closeBtn: true,
          openEffect: 'none',
          closeEffect: 'none',
          'beforeLoad': function () {
            $("#quick-view").html(content);
          },
          'afterShow': function () {

              function setCheapestVariant() {
                let cheapestVariant = product.variants[0];
                for (variant in product.variants) {
                  if (product.variants[variant].price < cheapestVariant.price) {
                    cheapestVariant = product.variants[variant];
                  }
                }
                let url = window.location.href;
                 if (!url.includes('?variant=')) {
                    $("#quick-view input[value='" + cheapestVariant.title + "']").click();
                    window.postMessage({
                      type: 'variant_changed',
                      variant: cheapestVariant
                    }, '*');
                  }
              }
            setTimeout(() => {
              setCheapestVariant();
            }, "1000");
          },
          'afterClose': function () {
            window.history.replaceState({ }, '', original_state);
            $('#quick-view').removeClass().empty();
          }
        });
      });
    });
  }
  if (!window.productFormLoaded) {
    $.getScript("//naturespath.com/cdn/shop/t/82/assets/product-form.js?v=96239604486755299301711714246").done(function() {
    quickView();
  });
  } else {
    quickView();
  }
  
});

